/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './checkbox.scss';
import './modifier/hide-label.scss';
import './modifier/align-right.scss';
import './modifier/small.scss';
